var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{attrs:{"id":"shell"}}),_c('div',{ref:"appShellRef",staticClass:"app-shell-ref"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }